import SearchIcon from "mdi-react/SearchIcon";
import React from "react"
import { withRouter } from "react-router-dom";
import Fire from "../../config/Fire";
import Aux from "../AuxFunctions";
import Colors from "../Colors";
import Loader from "./Loader";

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            usersData: [],
            searchText: "",
            isLoading: false,
            isUser: true,

            showSearchBar: false,

            loadingUsers: false,
            loadingTags: false,

            noUsers: false,
            noHashtags: false,
        }
    }

    goToSearch = (search, isHashtag) => {
        try {
            const a = `/search?q=${search}${isHashtag ? "&type=hashtag" : ""}`
            this.props.history.push(a)
            this.closeSearchBar()
        } catch (error) {
            Aux.handleError(error)
        }

    }

    goToUser= (user) =>{
        try {
            this.props.history.push(`/user/${user.username}`)
            this.closeSearchBar()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToHashtag= (tag) =>{
        try {
            this.props.history.push(`/hashtag/${tag.hashtag}`)
            this.closeSearchBar()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    closeSearchBar = () => {
        this.setState({ showSearchBar: false, usersData: [], tags: [], noUsers:false, noHashtags:false })
    }

    onEnterPressed = (e) => {
        if (e.key === "Enter") {
            this.onSearch()
        }
    }

    onSearch = async () => {
        this.inputSearch.focus();
        if (!this.state.showSearchBar) {
            this.setState({ showSearchBar: true })
            return;
        }
        if (this.state.loadingUsers || this.state.loadingTags)
            return
        try {
            if (this.state.searchText) {
                this.setState({ loadingUsers: true, loadingTags: true, usersData: [], tags: [], noHashtags: false, noUsers:false })
                let dataUsers = await Fire.shared.getSearchUser(this.state.searchText.toLowerCase(), 4)
                if (dataUsers) {
                    this.setState({ usersData: [...dataUsers], loadingUsers: false });
                }else{
                    this.setState({noUsers:true})
                }
                let dataTags = await Fire.shared.getSearchHashtag(this.state.searchText.toLowerCase(), 4)
                if (dataTags) {
                    this.setState({ tags: [...dataTags], loadingTags: false });
                }else{
                    this.setState({noHashtags:true})
                }
            }
            this.setState({ loadingUsers: false, loadingTags: false })
        } catch (error) {
            this.setState({ loadingUsers: false, loadingTags: false })
            Aux.handleError(error)
        }
    }

    renderProfile = (props) => {
        return (
            <div className="selectable-hover" style={{ display: "flex", alignItems: "center", justifyContent:"space-between", padding:"15px 20px", overflow:"hidden" }}
                onClick={() => this.goToUser(props.user)}>
                <div style={{display: "flex", alignItems: "center", overflow:"hidden"}}>
                    {Aux.showAvatar(40, props.user.avatar, props.user.username || "Unknown")}
                    <div style={{marginLeft:10, display:"flex", flexDirection:"column", overflow:"hidden", justifyContent:"center"}}>
                    <span style={{fontSize:15, textOverflow:"ellipsis", overflow:"hidden", color: Colors.darkText }}>{props.user.username}</span> 
                    {props.user.coinsSpent > 0 ?
                        <span style={{fontSize:13, textOverflow:"ellipsis", overflow:"hidden", color: Colors.softText, }}>{props.user.coinsSpent || 0}$</span>    
                    : null}
                    </div>
                </div>
                
            </div>
        )
    }

    renderHashtag = (props) => {
        return (
            <div className="selectable-hover" style={{ display: "flex", alignItems: "center", justifyContent:"space-between", padding:"15px 20px", overflow:"hidden" }}
                onClick={() => this.goToHashtag(props.tag)}>
                <div style={{display: "flex", alignItems: "center", overflow:"hidden"}}>
                    <div style={{marginLeft:10, display:"flex", overflow:"hidden", justifyContent:"center"}}>
                        <span style={{fontSize:15, textOverflow:"ellipsis", overflow:"hidden", color: Colors.darkText }}>#{props.tag.hashtag}</span> 
                        {props.tag.coins > 0 ?
                            <span style={{marginLeft:5, fontSize:15, textOverflow:"ellipsis", overflow:"hidden", color: Colors.softText, }}>({props.tag.coins || 0}$)</span>    
                        : null}
                    </div>
                </div>
                
            </div>
        )
    }

    render() {
        return (
            <div style={{ flexDirection: "column", }} className="top-bar-search-bar">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                        onBlur={(e) => {
                            //console.log(e.relatedTarget?.id)
                            if (e.relatedTarget?.id !== "search-clickable") {
                                this.closeSearchBar()
                            }
                        }}
                        ref={r => this.inputSearch = r}
                        value={this.state.searchText}
                        type="text" placeholder="Search..."
                        className="input-search"
                        style={{ width: this.state.showSearchBar ? 200 : 0, border: "none", fontSize: 16, marginLeft: 0, 
                            padding: this.state.showSearchBar ? "5px 5px" : "5px 0px", backgroundColor: "#eee",
                            outline: this.state.showSearchBar ? "2px lightblue solid" : "none" }}
                        onKeyDown={this.onEnterPressed} onChange={(e) => {
                            if (!e.target.value) {
                                this.setState({ searchText: "", tags: [], usersData: [] })
                            } else {
                                this.setState({ searchText: e.target.value })
                            }
                        }}>

                    </input>

                    <SearchIcon size={30} className="search-icon" tabIndex="-1" id="search-clickable" onClick={this.onSearch}
                        style={{padding:4, }}
                    >
                    </SearchIcon>
                </div>
                {(this.state.tags.length > 0 || this.state.loadingTags || this.state.noHashtags) || (this.state.usersData.length > 0 || this.state.loadingUsers || this.state.noUsers) ?
                <div tabIndex="-1" id="search-clickable" className="full-shadow" style={{ position: "absolute", top: 55, backgroundColor: "white", width: 250, maxHeight: 400, alignSelf:"center", borderRadius:10, padding:10, paddingBottom:20 }}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: 10 }}>
                                <span>Users</span>
                                <span style={{ fontSize: 13, color: Colors.mainColor }}
                                    onClick={() => this.goToSearch(this.state.searchText, false)} className="text-hover">
                                    Show all
                                </span>
                            </div>
                            {this.state.noUsers ?
                            <div style={{display:"flex", justifyContent:"center", fontSize:14, color: Colors.softText}}>
                                <span>No users found...</span>
                            </div>
                            :
                            this.state.loadingUsers ? <Loader></Loader> :
                                this.state.usersData.map((item, i) => (
                                   <this.renderProfile key={i} user={item}></this.renderProfile>
                                ))}
                    </div>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: 10 }}>
                                <span>Hashtags</span>
                                <span style={{ fontSize: 13, color: Colors.mainColor }}
                                    onClick={() => this.goToSearch(this.state.searchText, true)} className="text-hover">
                                    Show all
                                </span>
                            </div>
                            {this.state.noHashtags ?
                            <div style={{display:"flex", justifyContent:"center", fontSize:14, color: Colors.softText}}>
                                <span>No hashtags found...</span>
                            </div>
                            :
                            this.state.loadingTags ? <Loader></Loader> :
                                this.state.tags.map((item, i) => (
                                    <this.renderHashtag key={i} tag={item}></this.renderHashtag>
                                ))}
                        </div>
                </div>: null}
            </div>
        )
    }


}

export default withRouter(SearchBar)
